import type { Me, QuoteVertical, Vertical } from '$lib/types';

export type { Me, Vertical };

// Bootstrapped once after login; holds the current user and their
// accessible verticals.
class SessionState {
  me = $state<Me | null>(null);

  readonly isAdmin = $derived(this.me?.user.role === 'admin');

  // Quote-domain vertical slugs (hotel/builder/...) this user may create or
  // see quotations in. Admins implicitly get every seeded vertical via `me`
  // already returning all of them (see middleware.AccessibleVerticalIDs) —
  // this just maps the admin `verticals` table rows to the quote-domain
  // slug set the UI actually gates on (New-quote picker, pipeline filters).
  readonly accessibleQuoteVerticals = $derived(
    new Set((this.me?.verticals ?? []).map((v) => v.slug)) as Set<QuoteVertical>
  );

  setMe(me: Me) {
    this.me = me;
  }

  clear() {
    this.me = null;
  }
}

export const session = new SessionState();
